import CloseAccountModal from './CloseAccountModal';

export default CloseAccountModal;
